import trim from 'lodash/trim';
import isEmpty from 'validator/lib/isEmpty';

import { ScorecardQuestionInput, ScorecardQuestionType } from '@/types/schema';

import { MAX_SCORE } from '../../../consts';

export const isQuestionsEmpty = (questions?: ScorecardQuestionInput[] | null) => {
  return !questions?.length;
};

export const isQuestionTextEmpty = (text: string) => isEmpty(trim(text));

export const isAnyQuestionTextEmpty = (values: ScorecardQuestionInput[]) => {
  return values.some((question) => isQuestionTextEmpty(question.text));
};

export const getDefaultQuestionItem = (order: number): Omit<ScorecardQuestionType, 'id'> => ({
  text: '',
  maxScore: MAX_SCORE,
  order,
});
